import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IEmployee, ITeam } from '@signal/asp-data-commons';
import {  UpdateEmployeeDetails } from '../../store/team/team.actions';
import { TeamState } from '../../store/team/team.reducer';



@Injectable({
    providedIn: 'root'
})
export class TeamService {
    teamUpdate:ITeam[] = [];
  constructor(private teamState: Store<TeamState>) {}

  employeeUpdate(teamUpdate){
    if(teamUpdate.length==0){
      // this condition is to clear the teamUpdate:ITeam[] array
      this.teamUpdate = [];
    }
    else{
      this.teamUpdate.push(teamUpdate);
    }
  }
  dispatchEmployeeDetails() {
      if(this.teamUpdate && this.teamUpdate.length > 0){
        this.teamState.dispatch(new UpdateEmployeeDetails({teamUpdate:this.teamUpdate}));
      }
      this.teamUpdate = [];
  }
}